export default __webpack_public_path__ + "static/media/crc-hold-trx-color.94f623ca.svg";